import { Button, ButtonProps, Tooltip } from "@mui/material";

/** A concept review action whose backend does not exist yet. */
export const UnavailableButton = (props: Omit<ButtonProps, "disabled">) => (
  <Tooltip title="Not available yet" describeChild>
    <span className="inline-flex">
      <Button size="small" {...props} disabled />
    </span>
  </Tooltip>
);
